import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { ModuleTypes } from "@/store/ModuleTypes";
import moment, { Moment } from "moment";
import { getTeamEventsByMonth } from "@/helpers/api";

@Module({ namespaced: true, name: ModuleTypes.TEAM_CALENDAR })
export default class TeamCalendarModule extends VuexModule {
  loadingCounter = 0;
  layoutSelection = "list";
  month = new Date() as Date | Moment;
  showRelatedEvents = false;
  teamId = "";
  events = [];

  showPopup = false;
  clickEvent = null;
  popupEvent = null;

  playerInvites = [];

  get loadingCount() {
    return this.loadingCounter;
  }

  get layout() {
    return this.layoutSelection;
  }

  get selectedMonth() {
    return this.month;
  }

  get monthLabel() {
    return moment(this.month).format("MMMM, YYYY");
  }

  get eventColor() {
    return (event: any) => event.borderColor;
  }
  get eventStart() {
    return (event: any) => {
      console.log("inside eventStart " + event.start);
      return new Date(event.start);
    };
  }
  get eventEnd() {
    return (event: any) => new Date(event.end);
  }

  get filteredEvents() {
    return (related: boolean) =>
      related ? this.events : this.selectedTeamsEvents;
  }

  get selectedTeamsEvents() {
    const orgUnit: any = this.team || this.organization;
    return orgUnit
      ? this.events.filter(
          (event: any) => event.details.orgUnit.id === orgUnit.id
        )
      : [];
  }

  get relatedEvents() {
    const orgUnit: any = this.team || this.organization;
    return orgUnit
      ? this.events.filter(
          (event: any) => event.details.orgUnit.id !== orgUnit.id
        )
      : [];
  }

  get team() {
    const org = this.organization;
    return org
      ? org.teams.find((team: any) => team.id === this.teamId) || org
      : null;
  }

  get organization() {
    const playersAndTeams = this.context.rootState.playersAndTeams;
    const orgs = this.context.rootState.playersAndTeams.organizations;
    return (
      orgs &&
      orgs.find(
        (org: any) =>
          org.id === this.teamId ||
          org.teams.some((team: any) => team.id === this.teamId)
      )
    );
  }

  @Mutation
  incrementLoadingCounter() {
    this.loadingCounter++;
  }

  @Mutation
  decrementLoadingCounter() {
    this.loadingCounter--;
  }

  @Mutation
  setTeamId(id: string) {
    this.teamId = id;
  }

  @Mutation
  setLayoutSelection(layout: string) {
    this.layoutSelection = layout ? layout : this.layoutSelection;
  }

  @Mutation
  setShowRelatedEvents(param: string) {
    this.showRelatedEvents = param === "true";
  }

  @Mutation
  setShowPopup(param: any) {
    this.showPopup = param;
  }

  @Mutation
  setMonth(month: Date | Moment) {
    this.month = month;
  }

  @Action
  goToToday() {
    // this.month = new Date();
    this.context.commit("setMonth", moment(new Date()).toDate());
    this.getMonthsEvents(this.month);
  }

  @Mutation
  handleEventClick(e: any) {
    this.showPopup = true;
    this.clickEvent = e;
    this.popupEvent = e.event;
  }

  @Action
  fetchData(newTeamId: string) {
    this.context.commit("setTeamId", newTeamId);
    this.getMonthsEvents(this.month);
  }

  @Action
  prev() {
    const prevMonth = moment(this.month).subtract("month", 1);
    this.context.commit("setMonth", prevMonth.toDate());
    this.getMonthsEvents(prevMonth);
  }

  @Action
  next() {
    const nextMonth = moment(this.month).add("month", 1);
    this.context.commit("setMonth", nextMonth.toDate());
    this.getMonthsEvents(nextMonth);
  }

  @Action
  async changeTeam(newTeamId: string) {
    this.incrementLoadingCounter();
    await this.context.commit("setTeamId", newTeamId);
    await this.getMonthsEvents(this.month);
    this.decrementLoadingCounter();
  }

  @Mutation
  setEvents(events: any) {
    this.events = events;
  }

  @Mutation
  setPlayerInvites(invites: any) {
    this.playerInvites = invites;
  }

  @Action
  calendarChange(val: any) {
    const newMonth = moment(val.start.date);
    this.getMonthsEvents(newMonth);
  }

  //goToMonth
  @Action
  async getMonthsEvents(m: Date | Moment) {
    const month: Moment = moment(m);

    this.incrementLoadingCounter();
    if (this.teamId) {
      const events = await getTeamEventsByMonth(
        this.teamId,
        month.format("MM"),
        month.format("YYYY")
      );
      this.context.commit("setEvents", events);
    }
    this.decrementLoadingCounter();
  }
}
